
import React from 'react';
import { Tables } from '@/integrations/supabase/types';
import SuggestionCard from './SuggestionCard';
import LoadingState from './LoadingState';
import EmptyState from './EmptyState';

type Suggestion = Tables<'suggestions'>;

interface SuggestionsListProps {
  suggestions: Suggestion[];
  isLoading: boolean;
  onDeleteClick: (id: string) => void;
}

const SuggestionsList: React.FC<SuggestionsListProps> = ({ 
  suggestions, 
  isLoading, 
  onDeleteClick 
}) => {
  if (isLoading) {
    return <LoadingState />;
  }
  
  if (suggestions.length === 0) {
    return <EmptyState />;
  }
  
  return (
    <div className="space-y-4">
      {suggestions.map((suggestion) => (
        <SuggestionCard 
          key={suggestion.id}
          suggestion={suggestion}
          onDelete={onDeleteClick}
        />
      ))}
    </div>
  );
};

export default SuggestionsList;
